import styled from 'styled-components'
import { S_ButtonRow } from '../../../../../../_components/layout/ButtonRow'

export const S_DebtorDetails_Contacts = styled.div`
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    ${S_ButtonRow} {
      width: 100%;
    }
  }

  .edit-button-style {
    display: flex;
    flex-direction: row;
  }
  .icon {
    margin-right: 5px;
  }

  .cell.allow-line-break {
    white-space: pre;
  }
`

export const S_AddContactModal = styled.div`
  min-width: 35vw;
  max-width: 800px;

  .submit {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
  h2 {
    margin-bottom: 20px;
  }
`

export const S_Submit = styled.div`
  &.submit {
    ${(props) => props.hidden && 'display: none;'}
  }
`
